import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Import components
import Header from './components/Header';
import Footer from './components/Footer';
import Homepage from './components/Homepage';
import BulkDataPage from './components/BulkDataPage';
import CommunicationChannels from './components/CommunicationChannels';
import ContactUs from './components/ContactUs';
import Pricing from './components/Pricing';
import AboutUs from './components/AboutUs';
import PeakResourcesPage from './components/Resources';
import ContentBillingPage from './components/ContentBilling';
import GamifyEngagementPage from './components/Gamify';
import BulkSMSPage from './components/BulkSMSPage';
import AirtimeRewardsPage from './components/AirtimeRewards';
import ScrollToTop from './components/ScrollToTop';
import Careers from './components/Careers';
import BookDemo from './components/BookDemo';
import PrivacyPage from './components/Privacy';
import SustainabilityPage from './components/Sustainability';
import WhatsAppMarketingPage from './components/BulkWhatsappPage';
import DeveloperPortal from './components/DeveloperPortal';




function App() {

  return (
    <Router>
      <div className="App">
      <ScrollToTop />
        <Header />
        
        <main className="main-content">
          <Routes>
            {/* Main routes */}
            <Route path="/" element={<Homepage />} />
            <Route path="/bulk-data" element={<BulkDataPage />} />
            <Route path="/communication" element={<CommunicationChannels />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/resources" element={<PeakResourcesPage />} />
            <Route path="/content-billing" element={<ContentBillingPage />} />
            <Route path="/gamify" element={<GamifyEngagementPage />} />
            <Route path="/bulk-sms" element={<BulkSMSPage />} />
            <Route path="/airtime-rewards" element={<AirtimeRewardsPage />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/book-demo" element ={<BookDemo />} />
            <Route path="/privacy" element ={<PrivacyPage />} />
            <Route path="/sustainability" element ={<SustainabilityPage />} />
            <Route path="/bulk-whatsapp" element ={<WhatsAppMarketingPage />} />
            <Route path="/developers" element={<DeveloperPortal />} />






          </Routes>
        </main>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;
